import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


export interface TreeNodeData {
  id: string;
  name: string;
  type: 'gebaeude' | 'sektion' | 'room' | 'indicator';
  description?: string;
  indikator_name?: string;
  indikator_type?: string;
  indikator_number?: number;
  schwellenwert?: string;
  value?: string;
  symbol?: string;
  color?: string;
  notes?: string;
  systemtyp?: string;
  systemgruppe?: string;
  standort?: string;
  children: TreeNodeData[];
}

export interface ObjectStructureResponse {
  result: number;
  message: string;
  data: TreeNodeData[];
}

@Injectable({
  providedIn: 'root'
})
export class ObjektStrukturTreetableService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /**
   * Fetch complete object structure for a standort
   * Always fetches all items (active and inactive) - filtering is done in frontend
   */
  getObjectStructure(standortId: string): Observable<ObjectStructureResponse> {
    const url = `${this.apiUrl}/fetch-object-structure/${standortId}`;
    const params = { include_inactive: 'true' }; // Always fetch all items
    console.log('ObjektStrukturTreetableService: Making API call to:', url, 'with params:', params);
    return this.http.get<ObjectStructureResponse>(url, { params });
  }

  /**
   * Fetch complete object structure for a standort (always includes all items)
   */
  getObjectStructureWithHistory(standortId: string): Observable<ObjectStructureResponse> {
    const url = `${this.apiUrl}/fetch-object-structure/${standortId}`;
    console.log('ObjektStrukturTreetableService: Making API call to:', url);
    return this.http.get<ObjectStructureResponse>(url);
  }
}
